import React from 'react'
import { View } from 'react-native'
import { Theme } from '../enum/Theme'

const AppFooter: React.FC = () => {

    return (
        <View style={{ backgroundColor: Theme.foreground, justifyContent: 'center', alignItems: 'center', height: 30 }} />
    )
}

export default AppFooter
